import React, { memo } from 'react';

import Stack from '@mui/material/Stack';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { preferencesV2Selectors } from 'app-components/flux/preferences-v2';
import { useAppSelector } from 'hooks/redux';

import TopBarHelpMenu from './TopBarHelpMenu';
import TopBarNotifications from './TopBarNotifications';
import TopBarProfileMenu from './TopBarProfileMenu';
import TopBarSettings from './TopBarSettings';

const TopBarNavItems = memo(function TopBarNavItems() {
  const topBarNavEnabled = useAppSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'topBarNav'));
  const hideNavButtons = useAppSelector(
    (state) => preferencesV2Selectors.getPreferenceValue(state, 'gsfScreen', 'completed_gsf') !== 'completed_gsf',
  );

  // Only show top-bar nav when flag is explicitly true; otherwise show nothing so Header shows legacy nav (avoids showing in both places when flag is undefined).
  if (topBarNavEnabled !== true) return null;

  return (
    <Stack direction='row' gap={1} alignItems='center' justifyContent='flex-end'>
      {!hideNavButtons && <TopBarNotifications id='topbar-nav-notifications' />}
      <TopBarHelpMenu id='topbar-nav-help-menu' hideNavButtons={!hideNavButtons} />
      {!hideNavButtons && <TopBarSettings id='topbar-nav-settings' />}
      <TopBarProfileMenu id='topbar-nav-profile-menu' hideFeatures={hideNavButtons} />
    </Stack>
  );
});

export default TopBarNavItems;
